export default "__VITE_PUBLIC_ASSET__2733b7b7__"